export default class FreeSpinState {
	constructor(scene, stateMachine) {
		this.stateMachine = stateMachine;
		this.stateObject = scene;
		this.slotControls = scene.slotControls;
		this.spinButton = this.slotControls.slotSpinButton;
		this.autoSpinButton = this.slotControls.slotAutoSpinButton;
	}

	enterFrom(oldState) {
		console.log(this.toString() + ' - Enter From: ' + oldState.toString());
		if (this.spinButton !== null) {
			this.spinButton.longPressClickEvent.add(this.longPressSpin_Click, this);
			this.spinButton.clickEvent.add(this.spin_Click, this);
			this.spinButton.pointerDownEvent.add(this.spin_PointerDown, this);
			this.spinButton.longPointerDownEvent.add(this.spin_LongPointerDown, this);
		}
		if (this.autoSpinButton !== null) {
			this.autoSpinButton.clickEvent.add(this.autoSpin_Click, this);
		}
		this.slotControls.setControlActivity(false, this.slotControls.auto, false); // activity, spinButtonAcivity, autoSpinButtonAcivity
		console.log(this.toString() + '  - run free spin');
		this.stateObject.isFreeSpin = true;
		this.slotControls.applyFreeSpin();
		this.stateObject.runSlot();
		this.slotControls.setSpinButtonText(this.slotControls.freeSpins.toString());
	}

	exitTo(newState) {
		console.log(this.toString() + ' - Exit To: ' + newState.toString());
		if (this.spinButton !== null) {
			this.spinButton.longPressClickEvent.remove(this.longPressSpin_Click);
			this.spinButton.clickEvent.remove(this.spin_Click);
			this.spinButton.pointerDownEvent.remove(this.spin_PointerDown);
			this.spinButton.longPointerDownEvent.remove(this.spin_LongPointerDown);
		}
		if (this.autoSpinButton !== null) {
			this.autoSpinButton.clickEvent.remove(this.autoSpin_Click);
		}
	}

	//region input
	spin_PointerDown() {}

	spin_LongPointerDown() {}

	longPressSpin_Click() {
		this.slotControls.resetAutoSpinsMode();
		// and diisable input
		this.slotControls.setControlActivity(false, false, false); // activity, spinButtonAcivity, autoSpinButtonAcivity
	}

	spin_Click() {
		this.slotControls.resetAutoSpinsMode();
		// and diisable input
		this.slotControls.setControlActivity(false, false, false); // activity, spinButtonAcivity, autoSpinButtonAcivity
	}

	autoSpin_Click() {
		this.slotControls.resetAutoSpinsMode();
		// and diisable input
		this.slotControls.setControlActivity(false, false, false); // activity, spinButtonAcivity, autoSpinButtonAcivity
	}
	//endregion input

	//region old
	handleInput() {}

	physicsUpdate() {}
	//endregion old

	toString() {
		return 'FreeSpinState';
	}
}
